import React from 'react';
import { Link } from 'react-router-dom';
import AppDownloadSection from '../../components/AppDownloadSection/AppDownloadSection';
import {
  FaTag,
  FaMobileAlt,
  FaTrophy,
  FaUtensils,
  FaLeaf,
  FaClock,
  FaHeartbeat,
  FaChartLine,
  FaMotorcycle,
  FaUserTie,
} from 'react-icons/fa';
import modernKitchenImg from '../../assets/images/modern-kitchen.png';
import './WhyChooseUs.css';

const reasons = [
  {
    icon: <FaTag />,
    title: 'COMPETITIVE PRICE',
    desc: 'Benefit from competitive pricing without compromising on quality.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'CONVENIENCE',
    desc: 'Place your order online with ease and enjoy delivery directly to your doorstep.',
  },
  {
    icon: <FaTrophy />,
    title: 'PREMIUM QUALITY',
    desc: 'We are committed to using only the highest-quality, nutritious ingredients in every recipe.',
  },
  {
    icon: <FaUtensils />,
    title: 'TRADITIONAL RECIPES',
    desc: 'Enjoy meals prepared in accordance with authentic local traditional recipes, delivering a true taste of home.',
  },
  {
    icon: <FaLeaf />,
    title: 'DIETITIAN APPROVED',
    desc: 'Meals are thoughtfully developed in consultation with dietitians and nutritionists to address specific dietary requirements.',
  },
  {
    icon: <FaClock />,
    title: 'RELIABILITY',
    desc: 'Reliable service guarantees that your meals are delivered punctually on every occasion.',
  },
  {
    icon: <FaHeartbeat />,
    title: 'WELLNESS',
    desc: 'Our offerings are thoughtfully designed to promote health and strengthen immunity, suitable for all age groups.',
  },
  {
    icon: <FaChartLine />,
    title: 'SCALABILITY',
    desc: 'We manage orders of all sizes, from individual meals to large-scale institutional requirements.',
  },
];

const features = [
  {
    title: 'POWERED BY SMART TECHNOLOGY',
    desc: 'Our mobile app makes ordering healthy meals quick and effortless. Browse the menu, select your favorite dishes, customize as needed, and checkout securely with multiple payment options — all in just a few taps. Fast, simple, and convenient.',
    icon: <FaMobileAlt />,
  },
  {
    title: 'SEAMLESS ORDERS FOR CHEFS',
    desc: 'Once you place your order, our smart kitchen app assigns it to chefs at the nearest cloud kitchen. Your meal is freshly prepared, carefully packaged, and handed to our delivery partner for fast, safe delivery.',
    icon: <FaUserTie />,
  },
  {
    title: 'DELIVER WITH EASE',
    desc: 'Our delivery app guides partners along the fastest routes, helping them reach you quickly and efficiently. Clients and admins can track every order in real-time, ensuring fresh meals, timely delivery, and complete transparency.',
    icon: <FaMotorcycle />,
  },
];

const categories = [
  'Breakfast & Lunch',
  'Dinner & Snacks',
  'Individual & Bulk Orders',
  'Corporate & Event Catering',
  'School & College Catering',
  'Hospital & Senior Meals',
  'Meal Plans & Subscriptions',
  'Delivery & Pickup',
];

const WhyChooseUs = () => {
  return (
    <div className="why-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div className="container">
            <h1>WHY CHOOSE US</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Why Choose Us</span>
            </div>
          </div>
        </div>
      </div>

      {/* Reasons */}
      <section className="why-reasons">
        <div className="container">
          <div className="why-reasons__grid">
            {reasons.map((r, i) => (
              <div key={i} className="why-card">
                <div className="why-card__icon">{r.icon}</div>
                <h3>{r.title}</h3>
                <p>{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cloud Kitchen CTA */}
      <section className="why-cta">
        <div className="container">
          <div className="why-cta__content">
            <h2 className="section-title">
              FROM OUR CLOUD KITCHEN TO YOUR <span>HEALTHY LIFESTYLE.</span>
            </h2>
            <Link
              to="/our-menu"
              className="btn-primary"
              style={{ display: 'inline-block', alignSelf: 'flex-start' }}
            >
              GO TO MENU
            </Link>
          </div>
          <div className="why-cta__image">
            <img src={modernKitchenImg} alt="Cloud Kitchen" />
          </div>
        </div>
      </section>

      {/* Choose What You Love */}
      <section className="why-choose">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Choose</span>
            <h2 className="section-title">
              CHOOSE WHAT <span>YOU LOVE</span>
            </h2>
            <p className="section-desc">
              Pick exactly what suits your appetite and occasion — from everyday meals to special
              events — and enjoy fresh flavors, reliable service, and quality you can trust.
            </p>
          </div>
          <div className="why-choose__tags">
            {categories.map((cat, i) => (
              <span key={i} className="why-choose__tag">
                {cat}
              </span>
            ))}
          </div>
          <div className="why-choose__cta">
            <a
              href="https://play.google.com/store/apps/details?id=com.digirasa.client"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              ORDER NOW
            </a>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="why-features">
        <div className="container">
          <div className="why-features__grid">
            {features.map((f, i) => (
              <div key={i} className="feature-card">
                <div className="feature-card__icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* App Download */}
      <AppDownloadSection />
    </div>
  );
};

export default WhyChooseUs;
